<template>
  <div class='helpDetail'>
    <div class='con' v-if="details">
        <div class="title flex-center">{{details.title}}</div>
        <div class="time flex-center">{{details.updatedTime}}</div>
        <div class="video" v-if="details.videoUrl">
          <video controls>
                   <source :src="details.videoUrl" type="video/mp4">
            </video>
        </div>
        <div class="detail" v-html="details.content"></div>
    </div>

  </div>
</template>
<script>
import {getHelpInfo} from '@/api/api.mine.js';
  export default {
    data() {
      return {
        details:'',
        id:this.$route.query.id
      }
    },
   created(){
     this.getDetail();
    },
    methods: {
       getDetail(){
         getHelpInfo({id:this.id}).then(data=>{
             this.details=data.result;
         })
       },
    },
  }
</script>
<style lang="scss" >
.helpDetail{
  // padding:15px;
  height:100%;
  overflow: hidden;
  overflow-y: auto;
  font-size: .14rem;
  line-height: .22rem;
  background:#fff;
  .con{
      position: relative;
      background:#fff;
      padding:.15rem;
      border-radius: 4px;
      .title{
        font-weight: 550;
        font-size: .15rem;
        color: #000;
      }
      .time{
        color:#999;
        border-bottom: 1px solid #d8d8d8;
        padding:5px 10px 10px;
        font-size:.13rem;
      }
      .video{
        text-align: center;
        margin:.1rem auto;
        video{
          width: 98%;
          height: 180px;
          background: #000;
        }
      }
      .detail{
        margin: .1rem auto;
      }
  }
 

}
@media screen and(min-width:1024px){
  .con{
    width:500px;
    margin:0px auto;
  }
}
</style>